import { c as _c } from "react/compiler-runtime";
import { Badge } from "@/components/Badge";
import { Card } from "@/components/Card";
import { ExperienceHeader } from "@/components/section/journey/ExperienceHeader";
import { cn } from "@/utils/helpers";
import { ExperienceEntry } from "@/utils/interfaces";
import { Award, ClipboardList } from "lucide-react";
interface ExperienceDetailProps {
  experience: ExperienceEntry;
  isAnimating: boolean;
  responsibilitiesLabel: string;
  technologiesLabel: string;
}
export const ExperienceDetail = t0 => {
  const $ = _c(29);
  const {
    experience,
    isAnimating,
    responsibilitiesLabel,
    technologiesLabel
  } = t0;
  const {
    description,
    responsibilities: t1,
    technologies
  } = experience;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const responsibilities = t2;
  const t3 = isAnimating ? "opacity-0" : "opacity-100";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("p-8 transition-opacity duration-300 ease-in-out", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== experience) {
    t5 = <ExperienceHeader experience={experience} size="lg" className="mb-6" />;
    $[4] = experience;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== description) {
    t6 = <section aria-labelledby="experience-description"><p id="experience-description" className="body-base mb-6 leading-relaxed">{description}</p></section>;
    $[6] = description;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== responsibilities || $[9] !== responsibilitiesLabel) {
    t7 = responsibilities.length && <section className="mb-6" aria-labelledby="experience-responsibilities"><div className="flex items-center gap-2 mb-4"><ClipboardList className="w-5 h-5 text-(--color-accent-3)" aria-hidden="true" /><h3 id="experience-responsibilities" className="heading-4">{responsibilitiesLabel}</h3></div><ul className="flex flex-col gap-2">{responsibilities.map(_temp)}</ul></section>;
    $[8] = responsibilities;
    $[9] = responsibilitiesLabel;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Award className="w-5 h-5 text-(--color-accent-3)" aria-hidden="true" />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== technologiesLabel) {
    t9 = <div className="flex items-center gap-2 mb-4">{t8}<h3 id="experience-technologies" className="heading-4">{technologiesLabel}</h3></div>;
    $[12] = technologiesLabel;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== technologies) {
    t10 = technologies.map(_temp2);
    $[14] = technologies;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <ul className="flex flex-wrap gap-2">{t10}</ul>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t9) {
    t12 = <section aria-labelledby="experience-technologies">{t9}{t11}</section>;
    $[18] = t11;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
    t13 = <article>{t5}{t6}{t7}{t12}</article>;
    $[21] = t12;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13 || $[27] !== t4) {
    t14 = <Card hover={false} className={t4}>{t13}</Card>;
    $[26] = t13;
    $[27] = t4;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
};
function _temp(responsibility, index) {
  return <li key={index} className="body-base flex gap-2"><span aria-hidden="true">•</span><span>{responsibility}</span></li>;
}
function _temp2(tech) {
  return <li key={tech}><Badge>{tech}</Badge></li>;
}